import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchReports } from '../services/shipments';
import { FileDown } from 'lucide-react';

export default function Reports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchReports().then(setReports).finally(() => setLoading(false)); }, []);

  return (
    <div className="space-y-6" data-testid="reports-page">
      <div className="rounded-xl border border-white/10 bg-navy-900 overflow-hidden">
        {loading ? (
          <div className="p-8 text-sm text-slate-400">Loading reports…</div>
        ) : reports.length === 0 ? (
          <div className="p-10 text-center">
            <FileDown className="h-8 w-8 text-slate-500 mx-auto mb-3" />
            <div className="font-display text-lg text-white">No reports yet</div>
            <p className="text-sm text-slate-400 mt-1">Run a validation on any shipment to generate its first report.</p>
          </div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-navy-800/50 border-b border-white/5">
              <tr className="text-left text-xs text-slate-400 uppercase tracking-wider font-mono">
                <th className="px-5 py-3">Reference</th>
                <th className="px-5 py-3">Status</th>
                <th className="px-5 py-3">Open issues</th>
                <th className="px-5 py-3">Generated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {reports.map(r => (
                <tr key={r.id} className="border-b border-white/5 last:border-0 hover:bg-white/[0.02]" data-testid={`report-row-${r.shipment_reference}`}>
                  <td className="px-5 py-3 font-mono text-xs">{r.shipment_reference}</td>
                  <td className="px-5 py-3 capitalize">
                    <span className={
                      r.status === 'pass' ? 'text-emerald-400' :
                      r.status === 'warning' ? 'text-amber-400' :
                      r.status === 'blocking' ? 'text-red-400' : 'text-slate-300'
                    }>{r.status}</span>
                  </td>
                  <td className="px-5 py-3 text-slate-300">{r.open_issues}</td>
                  <td className="px-5 py-3 text-slate-400 text-xs font-mono">{new Date(r.generated_at).toLocaleString()}</td>
                  <td className="px-5 py-3 text-right">
                    <Link to={`/shipments/${r.shipment_id}?tab=report`} className="text-cyan-glow hover:text-cyan-hover text-xs">Open →</Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
